import React from 'react'
import styles from './Skeleton.module.scss'
import * as PropTypes from 'prop-types'
import clsx from 'clsx'

const sizeMap = {
  s: 36,
  m: 44,
  l: 52,
}
export const Item = ({
  bgColor = 'none',
  size = 'm',
  width = 0,
  height = 0,
  className = '',
  style = {},
  as: Component = 'div',
  ...rest
}) => (
  <Component
    className={clsx(styles['skeleton__line'], className, [
      `bg-color-static-${bgColor}`,
    ])}
    style={{
      width: width ? width + 'px' : '50%',
      height: (height ? height : sizeMap[size]) + 'px',
      ...style,
    }}
    {...rest}
  />
)

Item.propTypes = {
  size: PropTypes.oneOf(['s', 'sm', 'm', 'l']),
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  bgColor: PropTypes.string,
  style: PropTypes.object,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
